import React from "react";
import { FormattedMessage } from "react-intl";

export const LoadingSpinner = () => (
  <span className="fas fa-spinner text-success" />
);

export const Loading = () => (
  <p className="text-center">
    <LoadingSpinner /> <FormattedMessage id="ui.loading" />
  </p>
);
